import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { getCommunityInteractiveSitePlanMarkers } from 'constants/routes'

/**
 * Retrieves community interactive site plan markers associated with a given community id list.
 * @param {Object} payload - The payload containing the list of community ids.
 * @returns {Observable} - An observable that emits the community interactive site plans information.
 */
const getCommunityInteractiveSitePlans = (payload) => {
  const queryParams = new URLSearchParams({ communityIds: payload.communityIds });

  return fromFetch(`${getCommunityInteractiveSitePlanMarkers}?${queryParams.toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  }).pipe(
    switchMap((response) => response.json())
  );
};

export default getCommunityInteractiveSitePlans;